import {Component, inject} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import { SubscriptionService } from "../../../../../../core/services/connected/subscription.service";
import { Subscription } from "../../../../../../core/models/subscription.model";

@Component({
  selector: 'admin-onboarding-subscription',
  templateUrl: './admin-onboarding-subscription.page.html',
  styleUrls: ['./admin-onboarding-subscription.page.scss']
})
export class AdminOnboardingSubscriptionPage {

  readonly #subscriptionService = inject(SubscriptionService);
  readonly #router = inject(Router);
  readonly #activatedRoute = inject(ActivatedRoute);
  private _selectedSubscription: Subscription | null = null;

  readonly subscriptions$ = this.#subscriptionService.findAllActive(0, 20, '', 'id', 'asc');

  readonly #communityId: string = this.#activatedRoute.snapshot.params['communityId'];

  onSubscriptionSelected(subscription: Subscription) {
    this._selectedSubscription = subscription;
  }


  get selectedSubscription(): Subscription | null {
    return this._selectedSubscription;
  }

  isSelected(subscription: Subscription) {
    return this._selectedSubscription === subscription;
  }

  previousStep() {
    if(this.#communityId){
      this.#router.navigate(["/admin/onboarding/" + this.#communityId + "/address"])
    } else {
      this.#router.navigate(["/admin/onboarding/address"])
    }
  }

  submit() {
    this.#router.navigate(["/admin/onboarding", this.#communityId, "summary"],
      {
        state: {
          subscription: this._selectedSubscription,
        }
      })
  }

}
